<div>
  <h3 class="plugin-section-title">Template Details</h3>
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Template Name</mat-label>
    <input matInput [(ngModel)]="templateDetailsData.templateName" placeholder="Enter the name of the template">
  </mat-form-field>
  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Template Description</mat-label>
    <textarea matInput rows="4" [(ngModel)]="templateDetailsData.templateDescription" placeholder="Enter a description for the template"></textarea>
  </mat-form-field>
</div>
